import { render, staticRenderFns } from "./DragAndDropSortingStatement.vue?vue&type=template&id=334ce8d1&"
import script from "./DragAndDropSortingStatement.vue?vue&type=script&lang=ts&"
export * from "./DragAndDropSortingStatement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports